<template>
  <v-widget
    color="primary"
    dark
    class="px-4 py-4"
    v-bind="$attrs"
    :class="{
      'account-switch': (user && !user.broker) || !whiteBranding
    }"
  >
    <template #content>
      <v-row dense class="mt-2">
        <v-col cols="12" class="d-flex align-center">
          <v-icon class="mr-4">mdi-bank</v-icon>
          <span class="text-title white--text font-weight-medium">{{ $t(title) }}</span>
        </v-col>
      </v-row>
      <div class="d-flex align-center py-4">
        <v-autocomplete
          :filter="filterObject"
          class="account-select"
          dense
          item-text="code"
          :items="items"
          return-object
          hide-details
          :value="account && account"
          @input="handleAccount"
          ref="accountSwitch"
        >
          <template #item="{ item }">
            <p>
              <span class="font-weight-medium"> {{ item.code }} </span><br />
              <span class="grey--text text--darken-1">
                {{ item.firstname }} {{ item.lastname }}
              </span>
              <span class="font-weight-medium">({{ item.accountNumber }})</span>
            </p>
          </template>
        </v-autocomplete>
        <div class="ml-5">
          <span class="text-description white--text text-uppercase">{{ account.firstname }} {{ account.lastname }} ({{ account.accountNumber }})</span>
        </div>
      </div>
    </template>
  </v-widget>
</template>

<script>
import VWidget from '@/components/commons/VWidget'
import { mapState, mapActions } from 'vuex'
import AccountDataService from '@/services/accountData'

export default {
  components: { VWidget },
  props: {
    title: {
      type: String,
      default: 'portal_account_switch_title'
    },
    items: {
      type: Array
    }
  },
  computed: {
    ...mapState('account', ['account']),
    ...mapState('auth', ['user']),
    ...mapState('setting', ['whiteBranding'])
  },
  methods: {
    ...mapActions('account', ['setAccount', 'setAccountData']),
    handleAccount(account) {
      this.$refs.accountSwitch.blur()
      this.setAccount(account)
      this.$emit('accountSwitch')
      this.getAccountData()
    },
    async getAccountData() {
      try {
        const data = await AccountDataService.find(this.account.code)
        this.setAccountData(data)
      } catch (error) {
        console.log(error)
      }
    },
    filterObject(item, queryText) {
      let fullName =
        item.firstname.toLocaleLowerCase() +
        ' ' +
        item.lastname.toLocaleLowerCase()
      return (
        item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        fullName.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      )
    }
  }
}
</script>

<style lang="sass" scoped>
.text-title
  font-size: 1.2rem

.text-description
  font-size: 1.1rem
  font-weight: 500

.account-switch
  background: url('../../assets/account-swtich.webp') no-repeat center center
  background-size: cover

.account-select
  font-size: 1.1rem
  font-weight: 500
  max-width: 100px
  ::v-deep .v-input__slot::before
    border-style: none !important


.account-select.v-text-field > .v-input__control > .v-input__slot::before
  border: none

.account-select
  .v-icon
    font-size: 40px
  .v-autocomplete__content.v-menu__content
    border-radius: 10px !important

@media only screen and (min-width: 480px)
  .text-title
    font-size: 1.2rem
</style>
